import type { ReactNode } from 'react'
import { Typography } from '@/components/ui/typography'
import { cn } from '@/lib/utils'

interface MetricProps {
  label: ReactNode
  value: ReactNode
}

function PreviewMetric({ label, value }: MetricProps) {
  return (
    <div className="flex min-h-20 min-w-0 flex-col justify-center rounded-md border border-border/70 bg-background px-3 py-3">
      <Typography variant="label" tone="muted" className="block truncate">
        {label}
      </Typography>
      <Typography variant="h3" className="mt-2 pb-0 tabular-nums">
        {value}
      </Typography>
    </div>
  )
}

function BreakdownRow({ label, value }: MetricProps) {
  return (
    <div className="flex min-h-12 items-center justify-between gap-4 rounded-md border border-border/70 bg-background px-3 py-2">
      <Typography variant="bodySmall" tone="muted" className="min-w-0">
        {label}
      </Typography>
      <Typography variant="label" className="shrink-0 tabular-nums">
        {value}
      </Typography>
    </div>
  )
}

function BreakdownMetric({
  label,
  value,
  tone = 'default',
}: MetricProps & { tone?: 'default' | 'warning' }) {
  return (
    <div
      className={cn(
        'flex min-h-20 min-w-0 flex-col justify-center rounded-md border border-border/70 bg-background px-3 py-3',
        tone === 'warning' && 'border-status-warning-border bg-status-warning-background'
      )}
    >
      <Typography variant="label" tone="muted" className="block truncate">
        {label}
      </Typography>
      <Typography
        variant="label"
        tone={tone === 'warning' ? 'warning' : 'default'}
        className="mt-1 tabular-nums"
      >
        {value}
      </Typography>
    </div>
  )
}

export { BreakdownMetric, BreakdownRow, PreviewMetric }
